export default "__VITE_ASSET__68d2254c__"